// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"4aee95fd","453":"a930104a"}[chunkId] + ".chunk.js";
};